
import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import classnames from 'classnames'
import Box from './Box'

/**
 * Menu component.
 */

export default Menu

/**
 * Expose components.
 */

Menu.Item = Item
Menu.Group = Group
Menu.OptionsGroup = OptionsGroup
Menu.Divider = Divider

/**
 * Menu component.
 */

function Menu({ collapsible, full, small, children }) {
  const classes = classnames({
    Menu: true,
    collapsible,
    full,
    small
  })

  return <div className={classes}>
    {children}
  </div>
}

/**
 * Item component.
 */

function Item({ icon: Icon, children, selected, highlight, onSelect, ...props }) {
  const is = props.to
    ? highlight
      ? NavLink
      : Link
    : 'div'
  
  const classes = classnames({
    MenuItem: true,
    selected: selected,
  })

  function click(e) {
    e.stopPropagation()
    if (onSelect) onSelect(e)
  }

  return <Box is={is} className={classes} onClick={click} {...props}>
    {Icon && <Icon className="icon" />}
    <span className="text">{children}</span>
  </Box>
}

/**
 * Group component.
 */

function Group({ title, children }) {
  return <div className="MenuGroup">
    <div className="title">{title}</div>
    {children}
  </div>
}

/**
 * OptionsGroup component.
 */

function OptionsGroup({ title, options, selected, onChange }) {
  return <div className="MenuGroup options">
    {title && <div className="title">{title}</div>}
    {options.map(o => {
      return <Item
        key={o.value}
        selected={o.value == selected}
        onClick={e => (e.stopPropagation(), onChange(o.value))}
      >
        {o.label}
      </Item>
    })}
  </div>
}

/**
 * Divider component.
 */ 

function Divider() {
  return <div className="divider"></div>
}